module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_EN.1eba6387.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust_PDF/GDocsCookieNotice_EN.pdf
// module id = 287
// module chunks = 4